import { FC } from 'react';
import { scheduleOrder } from 'constants/schedule';

import Text from 'components/core/Text';

import { Container, Row, Cell, TextWrapper } from './styles';

const Sidebar: FC = () => (
  <Container>
    {scheduleOrder.map((day) => (
      <Row key={`${day}Title`}>
        <Cell>
          <TextWrapper>
            <Text variant="displayM" tag="span" transform="uppercase" color="gray" isResponsive>
              {day}
            </Text>
          </TextWrapper>
        </Cell>
      </Row>
    ))}
  </Container>
);

export default Sidebar;
